(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SubSeriesDialogController', SubSeriesDialogController);

    SubSeriesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'SubSeries'];

    function SubSeriesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, SubSeries) {
        var vm = this;
        vm.subSeries1 = [{stockName:'Hoàng Diệu',productCode:'HSCT2', productName:'Biên nhận hồ sơ',quantityInventory:'20000',seriesNum:'324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'},
                         {stockName:'Hoàng Diệu',productCode:'HSCT2', productName:'Giấy chứng nhận bảo hiểm',quantityInventory:'1500',seriesNum:'324245-34634636;324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'}];
        vm.subSeries= vm.subSeries1[0];
//        vm.budget = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.subSeries.code != null || vm.subSeries.code != undefined) {
       	 vm.checkcreat = true;
       	vm.subSeries.isExit = true;
       }else{
    	   vm.subSeries.isExit = false;
       }

        if(vm.subSeries.status == 1){
        	vm.subSeries.subSeries = true;
        }else{
        	vm.subSeries.subSeries = false;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if(vm.subSeries.subSeries == true){
        		vm.subSeries.status = 1;
        	}else{
        		vm.subSeries.status = 0;
        	}
            if (vm.subSeries.isExit == true) {
            	
            	SubSeries.update(vm.subSeries,function(result){
          		  $scope.$emit('masterApp:subSeriesUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	SubSeries.save(vm.subSeries,function(result){
        		  $scope.$emit('masterApp:subSeriesUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:subSeriesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
